module.exports = __webpack_public_path__ + "static/04-2f801321a367ab32dca6fb3dad1eb420.jpeg";